import { FileSaverOptions } from 'file-saver';
import { stringify } from 'csv-stringify/browser/esm';
import { BatchPostingCSVDetailsResponseDto, BatchPostingCSVRowStatus } from 'remarketing-angular-library';

interface SaveAsFunction {
  (data: Blob | string, filename?: string, options?: FileSaverOptions);
}

const enum BatchPostingCSVRowMappedStatus {
  SUCCESS = 'Success',
  FAIL = 'Fail'
}

const enum CSVRowHeaders {
  VIN = 'VIN',
  STATUS = 'Status',
  NOTES = 'Notes'
}

export class PostingFileDetailsExportService {
  private readonly csvColumns: any = [
    { key: 'vin', header: CSVRowHeaders.VIN },
    { key: 'status', header: CSVRowHeaders.STATUS },
    { key: 'notes', header: CSVRowHeaders.NOTES }
  ];

  constructor(
    private readonly saveAs: SaveAsFunction
  ) {}

  public createCSVFile(dto: BatchPostingCSVDetailsResponseDto): Promise<string> {
    const rows = dto.data ? dto.data.map(row => this.mapRow(row)) : [];
    return new Promise((resolve, reject) => {
      stringify(rows, { columns: this.csvColumns, header: true }, (err, data: string) => {
        if (err) {
          reject(err);
        } else {
          this.saveAs(new Blob([data]), dto.filename);
          resolve(data);
        }
      });
    });
  }

  private mapRow(row) {
    return {
      vin: row.vin,
      status: row.status === BatchPostingCSVRowStatus.COMPLETED ?
        BatchPostingCSVRowMappedStatus.SUCCESS : BatchPostingCSVRowMappedStatus.FAIL,
      notes: row.status === BatchPostingCSVRowStatus.COMPLETED ? row.vdpDeeplink : row.failureReason
    };
  }
}
